import { Inject, Injectable } from '@angular/core';
import { MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { RedirectRequest } from '@azure/msal-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserDetails } from '../business-entities/user-details';
import { SecureStorage } from './../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { environment } from 'projects/Administration/src/environments/environment';


@Injectable()
export class BaseService {
  loaderRef: NgbModalRef;
  isLoading: boolean;
  userDetails: UserDetails;
  userLoggedIn: boolean = false;
  public currentSignedIn: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    public modalService: NgbModal,
    private msalService: MsalService,
    private secureService: SecureStorage
  ) {
    this.currentSignedIn = new BehaviorSubject<any>(this.secureService.getKeyData('currentUser'));

  }

  showLoader(show: boolean) {
    // if (show && !this.isLoading) {
    //     this.loaderRef = this.modalService.open(LoaderComponent);
    //     this.isLoading = show;
    // } else if (this.loaderRef && !show) {
    //     this.loaderRef.dismiss();
    //     this.isLoading = show;
    // }
  }
  login() {
    if (this.msalGuardConfig.authRequest) {
      this.msalService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.msalService.loginRedirect();
    }
  }

  public get currentSignedInValue(): any {
    return this.currentSignedIn.value;
  }

  logout() { // Add log out function here
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri
    });
  }

  getSignedInUser(userDetails: UserDetails) {
    this.currentSignedIn.next(userDetails);
  }

  signout() {
    this.currentSignedIn.next(null);
    this.msalService.logoutRedirect();
  }
}
